import SortContext from "context/SortContext";
import React, { useEffect } from "react";
import CollectionScreen from "features/collection/components/CollectionScreen/CollectionScreen";
import { useFilter } from "context/FilterContext";
import { useGlobalContext } from "context/GlobalContext";
import { useLocation, useNavigate } from "react-router-dom";

function Collection() {
  const { setSortOptions, setSelectedSortValue, selectedSortValue, sortOptions } = React.useContext(SortContext);
  const { setBackendFilterValues, setFilterValues, setFilterCount, filterValues, appliedFilterValues, setAppliedFilterValues } = useFilter();
  const { setAppliedStartDate, setAppliedEndDate, setSelectedStartDate, setSelectedEndDate } = useGlobalContext();
  const location = useLocation();
  const navigate = useNavigate();

  // Collection Flow Navigation Done
  // When opened from CRM via window.open, decode ?crmState= and inject as router state.
  // localStorage cannot be used — CRM and Vision run on different origins (ports).
  useEffect(() => {
    if (location.state?.innerChnages) return;
    const params = new URLSearchParams(window.location.search);
    const encoded = params.get("crmState");
    if (!encoded) return;
    try {
      const crmState = JSON.parse(atob(encoded));
      navigate("/Collection", { replace: true, state: crmState });
    } catch (_) {}
  }, []);

  React.useEffect(() => {
    setFilterValues({});
    setBackendFilterValues({});
    setSortOptions([
      { id: 1, name: "Alphabetical Quote (A to Z) " },
      { id: 2, name: "Alphabetical Quote (Z to A)" },
      { id: 3, name: "Design Quantity (High to Low)" },
      { id: 4, name: "Design Quantity (Low to High)" },
      { id: 5, name: "Latest Created Time" },
      { id: 6, name: "Latest Modified Time" },
    ]);
    sessionStorage.setItem("AppliedDateFilter", "{}");

    return () => {
      setFilterValues({});
      setBackendFilterValues({});
      setSortOptions([]);
      setSelectedSortValue(null);
      setFilterCount(0);
      sessionStorage.setItem("filterChangeCount", 0);
      sessionStorage.removeItem("appliedSortValue");
    };
  }, []);

  useEffect(() => {
    sessionStorage.setItem("appliedSortValue", selectedSortValue);
  }, [selectedSortValue, sortOptions]);

  useEffect(() => {
    const fetchFilterData = async () => {
      try {
        let filterData = {
          aiCollectionFilter: ["Ai Collection", "User-created Collection"],
        };
        setBackendFilterValues(filterData);
        setFilterValues(filterData);
        if (sessionStorage.getItem("filterChangeCount") == 0) {
          setFilterValues(filterData);
        } else {
          if (Object.keys(appliedFilterValues).length === 0) {
            setFilterValues(filterData);
            setFilterCount(0);
            sessionStorage.setItem("filterChangeCount", 0);
          } else {
            setFilterValues(JSON.parse(sessionStorage.getItem("appliedFilterValues")));
          }
        }
      } catch (error) {
        console.error("Error fetching filter data:", error);
      }
    };
    fetchFilterData();
  }, [appliedFilterValues]);

  return <CollectionScreen />;
}

export default Collection;
